import Store from 'store/store'
import dot from 'dot-prop'

import Convert from 'utils/convert'
import File from 'controllers/file'
import APIServer from 'controllers/api-server'

const DEFAULT = {
  write: data => data,
  read: data => data,
  silent: false
}

export const KEYS = {
  formats: DEFAULT,
  regions: DEFAULT,
  logos: {
    write: async (logos = {}) => {
      for (const logo of logos) {
        if (logo.src) logo.src = await Convert.objectURL(logo.src).toDataURL()
      }
      return logos
    },
    read: async (logos = {}) => {
      for (const logo of logos) {
        if (logo.src) logo.src = await Convert.dataURL(logo.src).toObjectURL()
      }
      return logos
    }
  },
  cover: {
    write: async cover => {
      if (!cover || !cover.src) return
      cover.src = await Convert.objectURL(cover.src).toDataURL()
      return cover
    },
    read: async cover => {
      if (!cover || !cover.src) return
      cover.src = await Convert.dataURL(cover.src).toObjectURL()
      return cover
    }
  },
  'steps.lastReached': {
    write: DEFAULT.write,
    // Avoid discrepencies when loading a file exported from an instances with
    // more steps than this one
    read: data => Math.min(data, Store.steps.length.get() - 1)
  },
  'text.h1': DEFAULT,
  'text.h2': DEFAULT,
  'text.h3': DEFAULT,
  'text.h4': DEFAULT,
  'text.h5': DEFAULT,
  'text.h6': DEFAULT,
  'landscape.seed': DEFAULT,
  'landscape.colors': DEFAULT,
  'landscape.background': DEFAULT
}

for (const key in KEYS) {
  const signal = dot.get(Store, key)
  if (!signal) continue
  signal.subscribe(() => Store.app.isModified.set(true))
}

export async function save ({ download = true } = {}) {
  const json = {}
  const filename = Store.landscape.seed.get() + Store.constants.current.EXTENSION

  Store.app.isSaving.set(true)
  for (const key in KEYS) {
    const signal = dot.get(Store, key)
    const { write } = KEYS[key]
    if (!signal) continue

    json[key] = await write(signal.get())
  }

  if (download) {
    File.save(filename, { json })
    APIServer.log('save', { filename })
  }

  Store.app.isModified.set(false)
  Store.app.isSaving.set(false)

  return { filename, json }
}

export async function load (file) {
  file = File.isFile(file) ? file : await File.browse(Store.constants.current.EXTENSION)
  if (!file) return

  const result = await File.load(file, { method: 'readAsText' })
  const json = JSON.parse(result)

  for (const key in KEYS) {
    const signal = dot.get(Store, key)
    const { read, silent } = KEYS[key]
    if (!signal) continue

    const value = await read(json[key])
    if (value === null) continue

    if (silent) signal.current = value
    else signal.set(value)
  }
}



// WEBPACK FOOTER //
// ./src/store/file.js